import React, { useRef } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useRecoilCallback } from 'recoil'

import styled from '@emotion/styled'

import {
  makeButtonWithMenu,
  ContextMenu,
  CONTEXT_MENU_SIZE_SM
} from 'mailup-web-components'

import ChevronDownIcon from 'mailup-web-components/src/img/icons/chevron-down.svg'

import { modalBeeContentDialogSearchState } from '../recoil/state'
import { modalContentDialogSearchCallback } from '../recoil/callbacks'

const OrderByLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: var(--boulder);
  margin-right: 8px;
`

const OrderByValue = styled.span`
  font-size: 13px;
  color: var(--boulder);

  &::after {
    content: '';
    display: inline-block;
    margin-left: 5px;
    width: 8px;
    height: 8px;
    background: url(${ChevronDownIcon});
    background-size: 8px;
    background-position: center;
    background-repeat: no-repeat;
  }
`

const SearchContentsOrderBy = () => {
  const intl = useIntl()

  const { orderBy } = useRecoilValue(modalBeeContentDialogSearchState)

  const searchContents = useRecoilCallback(modalContentDialogSearchCallback, [])

  const { current: handleClickOption } = useRef(orderBy => {
    searchContents({ orderBy, pageNumber: 1 })
  })

  const { current: options } = useRef([
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentDate'
      }),
      value: 'ContentDate',
      onClick: handleClickOption
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentLoadingDate'
      }),
      value: 'ContentLoadingDate',
      onClick: handleClickOption
    }
  ])

  const selectedOption = options.find(({ value }) => value === orderBy)

  const Component = makeButtonWithMenu(
    () => (
      <>
        <OrderByLabel>
          {intl.formatMessage({ id: 'Load.TableHeader.Order' })}
        </OrderByLabel>
        <OrderByValue>{selectedOption.label}</OrderByValue>
      </>
    ),
    () => (
      <ContextMenu
        selected={orderBy}
        items={options}
        size={CONTEXT_MENU_SIZE_SM}
      />
    )
  )

  return <Component />
}
export default SearchContentsOrderBy
